import { Link } from "react-router-dom";
import { ArrowLeft, FileText, ShoppingCart, Download, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const AGB = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <Link to="/">
          <Button variant="ghost" className="mb-8 group">
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            Zurück zur Startseite
          </Button>
        </Link>

        <article className="prose prose-lg max-w-none">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-8">
            Allgemeine Geschäftsbedingungen (AGB)
          </h1>

          <div className="bg-card p-8 rounded-2xl shadow-soft border border-border mb-8">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                <FileText className="w-8 h-8 text-primary" />
              </div>
              <div>
                <h2 className="font-serif text-2xl font-bold text-foreground mb-1">
                  Vertragsbedingungen für den Erwerb digitaler Produkte
                </h2>
                <p className="text-muted-foreground">
                  Stand: November 2025
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-8 text-foreground/80">
            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                § 1 Geltungsbereich
              </h2>
              <p className="mb-4">
                Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Verträge über den 
                Erwerb digitaler Inhalte (E-Book) zwischen
              </p>
              <div className="bg-muted/30 p-4 rounded-lg mb-4">
                <p>
                  Osman Baltaci<br />
                  Durlachstr. 11<br />
                  44339 Dortmund<br />
                  Deutschland<br />
                  (nachfolgend "Anbieter")
                </p>
              </div>
              <p>
                und dem Kunden (nachfolgend "Kunde").
              </p>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <ShoppingCart className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-serif text-2xl font-bold text-foreground">
                  § 2 Vertragsgegenstand
                </h2>
              </div>
              <p className="mb-4">
                Gegenstand des Vertrages ist das E-Book "Heilkraft der Natur: Die vier Säulen der Vitalität" 
                im PDF-Format. Der Kunde erhält eine einfache, nicht ausschließliche und nicht übertragbare 
                Nutzungslizenz für den privaten Gebrauch.
              </p>
              <p className="mb-4">
                Das E-Book wird ausschließlich in digitaler Form über die Plattform Payhip zum Download 
                bereitgestellt.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                § 3 Vertragsschluss
              </h2>
              <ol className="list-decimal pl-6 space-y-3 mb-4">
                <li>
                  Die Darstellung des E-Books auf dieser Website stellt kein rechtlich bindendes Angebot dar, 
                  sondern eine unverbindliche Aufforderung zur Bestellung.
                </li>
                <li>
                  Durch Klicken auf den Button "Jetzt kaufen" gibt der Kunde ein verbindliches Angebot zum 
                  Erwerb des E-Books ab.
                </li>
                <li>
                  Der Kunde wird über die Plattform Payhip zur Kaufabwicklung weitergeleitet.
                </li>
                <li>
                  Der Vertrag kommt zustande, wenn der Anbieter die Bestellung durch Übersendung des 
                  Download-Links per E-Mail annimmt.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                § 4 Preise und Zahlungsbedingungen
              </h2>
              <p className="mb-4">
                Die auf der Website genannten Preise sind Endpreise in Euro und verstehen sich inklusive der 
                gesetzlichen Umsatzsteuer.
              </p>
              <p className="mb-4">
                Die Zahlung erfolgt über Payhip. Der Kunde kann zwischen verschiedenen Zahlungsmethoden 
                (Kreditkarte, PayPal, etc.) wählen.
              </p>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Download className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-serif text-2xl font-bold text-foreground">
                  § 5 Bereitstellung und Download
                </h2>
              </div>
              <p className="mb-4">
                Nach erfolgreichem Zahlungseingang erhält der Kunde eine E-Mail mit einem Download-Link für 
                das E-Book.
              </p>
              <p className="mb-4">
                Der Download-Link ist zeitlich unbegrenzt gültig und kann mehrfach verwendet werden.
              </p>
              <p className="mb-4">
                Der Kunde ist selbst für die Sicherung und Aufbewahrung des heruntergeladenen E-Books 
                verantwortlich.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                § 6 Nutzungsrechte
              </h2>
              <p className="mb-4">
                Der Kunde erhält ein einfaches, nicht übertragbares Nutzungsrecht für den privaten Gebrauch.
              </p>
              <p className="mb-4">Folgende Handlungen sind untersagt:</p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>Vervielfältigung und Verbreitung des E-Books</li>
                <li>Öffentliche Zugänglichmachung</li>
                <li>Bearbeitung oder Umgestaltung</li>
                <li>Gewerbliche Nutzung</li>
                <li>Weitergabe an Dritte (kostenlos oder gegen Entgelt)</li>
              </ul>
              <p>
                Das Urheberrecht verbleibt beim Anbieter.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                § 7 Widerrufsrecht
              </h2>
              <p className="mb-4">
                Verbrauchern steht grundsätzlich ein gesetzliches Widerrufsrecht zu.
              </p>
              <div className="bg-amber-50 dark:bg-amber-950/20 border-2 border-amber-200 dark:border-amber-800 p-6 rounded-xl mb-4">
                <div className="flex items-start gap-3">
                  <AlertCircle className="w-6 h-6 text-amber-600 dark:text-amber-400 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-foreground mb-2">Wichtiger Hinweis zum Widerrufsrecht:</h3>
                    <p className="text-sm text-foreground/80 mb-3">
                      Das Widerrufsrecht erlischt vorzeitig bei Verträgen zur Lieferung von digitalen Inhalten, 
                      die nicht auf einem körperlichen Datenträger geliefert werden, wenn der Unternehmer mit der 
                      Ausführung des Vertrags begonnen hat, nachdem der Verbraucher:
                    </p>
                    <ul className="list-disc pl-6 space-y-1 text-sm text-foreground/80">
                      <li>ausdrücklich zugestimmt hat, dass der Unternehmer mit der Ausführung des Vertrags vor 
                        Ablauf der Widerrufsfrist beginnt, und</li>
                      <li>seine Kenntnis davon bestätigt hat, dass er durch seine Zustimmung mit Beginn der 
                        Ausführung des Vertrags sein Widerrufsrecht verliert.</li>
                    </ul>
                    <p className="text-sm text-foreground/80 mt-3">
                      Mit dem Download des E-Books erlischt Ihr Widerrufsrecht.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <AlertCircle className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-serif text-2xl font-bold text-foreground">
                  § 8 Haftungsausschluss
                </h2>
              </div>
              <p className="mb-4">
                Das E-Book dient ausschließlich Informationszwecken und ersetzt keine medizinische, 
                therapeutische oder anderweitige fachliche Beratung.
              </p>
              <p className="mb-4">
                Die Anwendung der im E-Book beschriebenen Heilmittel und Methoden erfolgt auf eigene 
                Verantwortung. Der Anbieter übernimmt keine Haftung für gesundheitliche Schäden oder andere 
                Folgen, die aus der Anwendung der Informationen entstehen könnten.
              </p>
              <p className="mb-4">
                Der Anbieter übernimmt keine Gewähr für die Vollständigkeit, Richtigkeit und Aktualität der 
                Inhalte. Bei gesundheitlichen Beschwerden konsultieren Sie bitte einen qualifizierten Arzt 
                oder Heilpraktiker.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                § 9 Gewährleistung
              </h2>
              <p className="mb-4">
                Es gelten die gesetzlichen Gewährleistungsrechte. Der Anbieter gewährleistet, dass das E-Book 
                frei von Rechten Dritter ist und in der beschriebenen digitalen Form bereitgestellt wird.
              </p>
              <p className="mb-4">
                Bei technischen Problemen mit dem Download kontaktieren Sie bitte den Anbieter unter 
                osmanbaltaci@hotmail.com.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                § 10 Streitbeilegung
              </h2>
              <p className="mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die 
                Sie unter{" "}
                <a 
                  href="https://ec.europa.eu/consumers/odr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  https://ec.europa.eu/consumers/odr
                </a>{" "}
                finden.
              </p>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                § 11 Schlussbestimmungen
              </h2>
              <p className="mb-4">
                Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
              </p>
              <p className="mb-4">
                Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, berührt dies die 
                Wirksamkeit der übrigen Bestimmungen nicht.
              </p>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
};

export default AGB;
